import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useForm, Controller, useFieldArray } from 'react-hook-form';
import FormControlLabel from '@mui/material/FormControlLabel';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Checkbox from '@mui/material/Checkbox';
import DatePicker from '@mui/lab/DatePicker';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  CardContent,
  Autocomplete,
  TextField,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import _ from 'lodash';
import dayjs from 'dayjs';
import { format, isValid, parse } from 'date-fns';
import DateSelet from 'components/common/dateSelect/DateSelete';
import Loading from 'components/Loading';
import { ViewTitle } from 'components/ViewTitle';
import { BackButton } from 'components/Button';
import SumDiscount from '../../../components/Card/SumDiscount';
import Sumprice from 'components/Card/Sumprice';
import SumAllPrice from 'components/Card/SumAllPrice';
import ProductServe from '../../../components/Forms/FormProductArray';
import * as actions from '../../../redux/action';

function CreateQt({ title, subtitle }) {
  dayjs.extend(buddhistEra);
  const dispatch = useDispatch();
  const history = useHistory();
  const quotation = useSelector((state) => state.quotation);
  const customer = useSelector((state) => state.customer);
  const product = useSelector((state) => state.product);
  const [findName, setFindName] = useState('');
  const [page, setPage] = React.useState(1);
  const [size, setSize] = React.useState('');
  const [date, setDate] = React.useState(format(new Date(), 'y-MM-dd'));
  const [dueDate, setDueDate] = React.useState(format(new Date(), 'y-MM-dd'));
  const [productList, setProductList] = useState([]);
  const [customerData, setCustomerData] = useState();
  const [paymentType, setPaymentType] = useState('โอน/เงินสด');
  const [productVat, setProductVat] = useState(false);
  const [productVatUni, setProductVatUni] = useState(false);
  const [vatNumber, setVatNumber] = useState(0);

  const { handleSubmit, control, setValue, watch } = useForm({
    defaultValues: {
      payment: 'โอน/เงินสด',
    },
  });

  useEffect(() => {
    dispatch(actions.getAllCustomer({}));
    dispatch(actions.getAllProduct({}));
    dispatch(actions.getAllCustomer({}));

    return () => {};
  }, []);
  useEffect(() => {
    setDate(quotation?.date);
    setProductList(quotation?.product);
    if (!quotation.isloading) {
      setValue('productArray', quotation?.product);
    }

    setValue('businessname', quotation?.customer?.businessname);
    setValue('taxId', quotation?.customer?.TaxId);
    setValue('tel', quotation?.customer?.tel);
    setValue('name', quotation?.customer?.name);
    setValue('address', quotation?.customer?.address);
    setValue('payment', quotation?.payment);
    setValue('credit', quotation?.credit);
    setValue('note', quotation?.note);
    setValue('running_number', quotation?.running_number);
    setVatNumber(quotation?.vatNumber);
    setProductVat(quotation?.statusTax);
    setProductVatUni(quotation?.statusTaxUni);

    return () => {};
  }, [quotation]);
  console.log('name', quotation?.customer?.businessname);
  console.log('Test quotation', quotation);
  console.log('Payment', quotation?.payment);
  // console.log("product", quotation.product);

  const handleCheckCustomer = (data) => {
    const customers = _.find(customer.arr, { _id: data?._id });
    setCustomerData(customers);
    setValue('taxId', customers?.TaxId);
    setValue('tel', customers?.tel);
    setValue('address', customers?.address);
    setValue('note', customers?.note);
    //setValue('vat', customers?.vat);

    // setValue(customer?.statusTaxUni);
    // setValue(customer?.statusTax);
    console.log('dataCreateQT', data, customers?.vat);
  };
  console.log('watch payment', watch('payment'));
  console.log('watch date', watch('date'));
  console.log('watch vat', watch('vat'));
  console.log('watch note', watch('note'));

  const onSubmitQuotation = async (data) => {
    if (data?.productArray?.length === 0) alert('กรุณาเพิ่มสินค้า');
    else {
      try {
        const ProcessData = await {
          date,
          ...data,
          prefix: `QT${dayjs(date).format('BB')}-`,
          dueDate,
          payment: paymentType,
          customer: customerData?._id,
          product: data?.productArray,
          allPrice: SumAllPrice(),
          vatNumber: vatNumber,
          statusTax: productVat,
          statusTaxUni: productVatUni,
        };
        console.log('dataSubmit', ProcessData);
        console.log('vatnum', vatNumber);

        await dispatch(actions.addQuotation(ProcessData));
        await dispatch(actions.getAllQuotation({ findName, page, size }));
        history.push('/sale/quotation');
        console.log('ProcessData', data?.productArray);
      } catch (error) {}
    }
    console.log('data payment', data);
  };

  const tax = () => {
    const price = SumAllPrice(productList);
    const taxAll = price * 0.07;
    return taxAll;
  };

  const PriceVatNum = () => {
    const price = SumAllPrice(productList);
    const taxPriceVat = price * (vatNumber / 100);
    console.log('SumAllPrice', SumAllPrice(productList), taxPriceVat);
    return isNaN(taxPriceVat) ? 0 : taxPriceVat;
  };

  const taxProductVat = () => {
    if (!productVat) {
      return 0;
    }
    const priceProductVat = SumAllPrice(productList);
    const taxProductVat = priceProductVat * 0.03;
    return taxProductVat;
  };

  const taxUniversity = () => {
    if (!productVatUni) {
      return 0;
    }
    const priceUniversity = SumAllPrice(productList);
    const taxUniversity = priceUniversity * 0.01;
    return taxUniversity;
  };
  console.log('payment ', paymentType);

  console.log('TaxUni', taxUniversity());
  const priceTax = () => SumAllPrice(productList) + tax();
  const priceTaxUni = () => priceTax() - taxUniversity();
  const priceTaxAll = () => priceTax() - PriceVatNum();
  const priceProductVat = () => priceTax() - taxProductVat();
  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (customer.isloading && product.isloading) {
    return <Loading isloading />;
  }
  if (!customer.isloading && !product.isloading) {
    return (
      <div className="min-h-screen">
        <div>
          {renderTitle()}
          <BackButton />
        </div>
        <div className="py-2">
          <div>
            <div>
              <div className="flex">
                <Card>
                  <div className="p-2">
                    <h1 className="pb-4"> ข้อมูลลูกค้า</h1>
                    <div className="w-full">
                      <div className='"w-2/3'>
                        <Autocomplete
                          disablePortal
                          id="free-solo-demo"
                          freeSolo
                          options={customer?.arr || []}
                          getOptionLabel={(option) => option.businessname}
                          onChange={(e, newValue) =>
                            handleCheckCustomer(newValue)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="ชื่อลูกค้า"
                              required
                            />
                          )}
                        />{' '}
                      </div>
                    </div>
                    <Controller
                      name="taxId"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={field.value}
                          label="หมายเลขผู้เสียภาษี"
                          variant="outlined"
                          margin="normal"
                          fullWidth
                        />
                      )}
                    />
                    <Controller
                      name="tel"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={field.value}
                          id="outlined-basic"
                          label="เบอร์โทร"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                    />
                    <Controller
                      name="address"
                      defaultValue=""
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          value={field.value}
                          id="outlined-multiline-basic"
                          label="ที่อยู่"
                          variant="outlined"
                          fullWidth
                          multiline
                          margin="normal"
                          rows={4}
                        />
                      )}
                    />
                  </div>
                </Card>

                <div className="p-2 w-full">
                  <Card>
                    <CardContent>
                      {' '}
                      <form onSubmit={handleSubmit(onSubmitQuotation)}>
                        <div className="flex justify-between">
                          <div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                label="วันที่"
                                value={date}
                                onChange={(newValue) => {
                                  setDate(newValue);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </LocalizationProvider>{' '}
                          </div>
                          <div>{/* <DateSelet /> */}</div>
                          <Button
                            variant="contained"
                            type="submit"
                            // onClick={onSubmitQuotation}
                          >
                            บันทึก
                          </Button>
                        </div>
                        {/* <div className="py-2">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              label="วันที่กำหนดส่ง"
                              value={dueDate}
                              onChange={(newValue) => {
                                setDueDate(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </LocalizationProvider>{' '}
                        </div> */}
                        <Controller
                          name="credit"
                          control={control}
                          defaultValue="-"
                          render={({ field }) => (
                            <TextField
                              {...field}
                              value={field.value}
                              label="จำนวนวันเครดิต"
                              variant="outlined"
                              margin="normal"
                              fullWidth
                            />
                          )}
                        />
                        <TextField
                          id="outlined-controlled"
                          label="Controlled"
                          value={'โอนเงิน/เงินสด'}
                          onChange={(e) => {
                            setPaymentType(e.target.value);
                          }}
                        />
                      </form>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </div>
            <div>
              <div className="mt-2">
                <ProductServe
                  setProductList={setProductList}
                  setValue={setValue}
                  control={control}
                  watch={watch}
                  statusHide={false}
                  statusPickUp={false}
                  statusUni={false}
                />
              </div>
              <Card>
                <CardContent>
                  <div className="flex w-full ">
                    <div className="w-1/2">
                      {' '}
                      <Controller
                        name="note"
                        defaultValue=""
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            value={field.value}
                            id="outlined-multiline-basic"
                            label="หมายเหตุ"
                            variant="outlined"
                            fullWidth
                            multiline
                            margin="normal"
                            rows={4}
                          />
                        )}
                      />
                    </div>

                    <div className="flex justify-between  w-1/2 ml-2  ">
                      <div>
                        <div>รวมเงิน </div>
                        <div>ส่วนลดการค้า</div>
                        <div>เงินหลังหักส่วนลด</div>
                        <div>ภาษีมูลค่าเพิ่ม 7%</div>
                        <div className="flex pb-4">
                          <div>หัก ณ ที่จ่าย</div>
                          <div className="pl-2 ">
                            <TextField
                              sx={{
                                width: '40px',
                                '& .MuiInputBase-root': { height: '25px' },
                              }}
                              value={vatNumber}
                              onChange={(e) => {
                                setVatNumber(e.target.value);
                              }}
                            />
                          </div>
                          <div className="pl-2">%</div>
                        </div>

                        <div className="font-bold ">จำนวนเงินทั้งสิ้น </div>
                      </div>
                      <div>
                        <div>
                          <div>
                            {Sumprice(productList)
                              ?.toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                          </div>

                          <div>
                            {SumDiscount(productList)
                              ?.toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                          </div>

                          <div>
                            {SumAllPrice(productList)
                              ?.toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                          </div>
                          <div>
                            {tax()
                              ?.toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                          </div>

                          <div className="flex pb-4">
                            {PriceVatNum()
                              ?.toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                          </div>

                          <div className="font-bold ">
                            {priceTaxAll()
                              ?.toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return <>error</>;
}
export default CreateQt;
